import React from "react";

const MobileSectionSeperator = ({ order, margin }) => {
  return <div className="mobileSectionSeperator" style={{ order: order ?? "", margin: margin ?? "" }}></div>;
};

export default MobileSectionSeperator;
